import _ from "underscore";
import environment from "web/script/modules/environment";
import googleConversion from "web/script/embedded/google-conversion";

export default {
    // Search related conversion actions
    conversionIdSearch: 982977399,
    conversionLabel: "KvA6CL_g7pABEPeW3NQD",

    // CSS related conversion actions
    conversionIdsCSS: {
        "lyst.co.uk": 827715413,
        "lyst.de": 788956605,
        "lystapp.be": 788956605,
        "lyst.at": 788956605,
        "lyst.ch": 788956605,
        "lyst.com.nl": 788956605,
        "lyst.fr": 807037325,
        "lyst.es": 801694380,
        "lyst.it": 783391789,
        "lyst.com": 778294182,
    },
    conversionLabelsCSS: {
        "lyst.co.uk": "pWPzCOCzvMoBENXe14oD",
        "lyst.de": "nHS1CL_u08oBEL2LmvgC",
        "lystapp.be": "nHS1CL_u08oBEL2LmvgC",
        "lyst.at": "nHS1CL_u08oBEL2LmvgC",
        "lyst.ch": "nHS1CL_u08oBEL2LmvgC",
        "lyst.com.nl": "nHS1CL_u08oBEL2LmvgC",
        "lyst.fr": "dloZCI3q4soBEI3T6YAD",
        "lyst.es": "ekuVCI-X78oBEKzFo_4C",
        "lyst.it": "SPcvCIPu08oBEK24xvUC",
        "lyst.com": "2YOKCK_hhssBEKanj_MC",
    },
    conversionCurrenciesCSS: {
        "lyst.co.uk": "GBP",
        "lyst.de": "EUR",
        "lystapp.be": "EUR",
        "lyst.at": "EUR",
        "lyst.ch": "EUR",
        "lyst.com.nl": "EUR",
        "lyst.fr": "EUR",
        "lyst.es": "EUR",
        "lyst.it": "EUR",
        "lyst.com": "EUR",
    },
    domain: null,

    init: function(analytics) {
        googleConversion("config", "AW-" + this.conversionIdSearch, { send_page_view: false });
        let domain = analytics._getCookieDomain();
        if (domain in this.conversionIdsCSS) {
            googleConversion("config", "AW-" + this.conversionIdsCSS[domain], {
                send_page_view: false,
            });
            this.domain = domain;
        }
    },

    send: function(data) {
        // this will contain any promises we generate
        var promises = [];

        _.each(data, (event) => {
            if (event.type === "page_view") {
                let adwordsPayload = {
                    google_remarketing_only: true,
                };
                if (event.data.product_id) {
                    adwordsPayload.ecomm_prodid = event.data.product_id;
                    adwordsPayload.ecomm_pagetype = "product";
                }
                if (event.data.paid_no_retarget) {
                    adwordsPayload.no_retarget = event.data.paid_no_retarget;
                }
                if (event.data.life_cycle_stage) {
                    adwordsPayload.life_cycle_stage = event.data.life_cycle_stage;
                }
                // Send to default group - all accounts
                googleConversion("event", "page_view", adwordsPayload);
            } else if (
                event.type === "event" &&
                event.data.category === "affiliate" &&
                (event.data.action === "lead" || event.data.action === "lead_sold_out")
            ) {
                // Remarketing pixel, send to default group - all accounts
                promises.push(createGtagPromise("page_view", { value: 0 }));

                // Search Top level Conversion pixel
                promises.push(
                    createConversionGtagPromise(
                        this.conversionIdSearch,
                        this.conversionLabel,
                        environment.get("averageNetCommission"),
                        "USD"
                    )
                );

                // CSS conversion pixel
                let averageRPC = environment.get("averageRPC");
                if (this.domain in this.conversionIdsCSS && averageRPC) {
                    promises.push(
                        createConversionGtagPromise(
                            this.conversionIdsCSS[this.domain],
                            this.conversionLabelsCSS[this.domain],
                            averageRPC,
                            this.conversionCurrenciesCSS[this.domain]
                        )
                    );
                }
            }
        });

        // wait for any promises what we were asked to wait for
        return Promise.all(promises);
    },
};

function createGtagPromise(event, data) {
    return new Promise((resolve) => {
        // create gtag
        data.event_callback = resolve;
        googleConversion("event", event, data);
    });
}

function createConversionGtagPromise(id, label, value, currency) {
    let data = {
        send_to: "AW-" + id + "/" + label,
        currency: currency,
        value: value,
        label: label,
    };

    return createGtagPromise("conversion", data);
}
